/** Customer-facing colour name (no internal numbers). */
export function displayCandlePenColorLabel(rawLabel: string): string {
  if (/glow/i.test(rawLabel)) {
    return 'GLOW IN THE DARK'
  }
  return rawLabel.replace(/[\s-]*\d+$/, '').replace(/\s+/g, ' ').trim()
}
